<template>
  <v-menu class="menu" offset-y open-on-hover>
    <template v-slot:activator="{ on }">
      <div class="avatar" v-on="on">
        <div
          class="avatar_body d-flex align-center"
          :style="size ? 'width:' + size + 'px;' + 'height:' + size + 'px' : ''"
          id="avatar"
        >
          <v-img
            class="br50"
            v-if="userData.photo"
            :src="apiDomain + '/min/' + userData.photo"
            :height="size"
            :width="size"
            alt=""
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="#ffffff"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-avatar v-else-if="userData" size="48" color="white" class="primary--text fw500">
            <div class="d-flex align-center">
              <v-icon class="primary--text" size="18">mdi-account</v-icon>
              {{ userData.first_name.charAt(0) + userData.last_name.charAt(0) }}
            </div>
          </v-avatar>
        </div>
      </div>
    </template>
    <v-list class="pa-0 avatarList">
      <v-list-item class="email" :title="userData.email">
        <span>{{ userData.email }}</span>
      </v-list-item>
      <v-list-item @click="$router.push({ name: 'PersonalArea' })"
        ><span>{{ localStorage.translations.pages.setting.pages['lichnyy-kabinet'] }}</span>
      </v-list-item>
      <v-list-item class="exit" @click="onExit()">
        <span>{{ localStorage.translations.pages.auth.buttons.vyhod }}</span>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'HeaderAvatarMenu',
  props: {
    size: {
      type: [String, Number],
      default: 40,
    },
  },
  data() {
    return {
      modal_logout: false,
    }
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
    userData() {
      return this.$store.getters['user/userData']
    },
  },
  methods: {
    onExit() {
      this.$emit('exit', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar {
  height: 100%;
  display: grid;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  transition: 0.3s;
  cursor: pointer;

  .avatar_body {
    border-radius: 50%;
    background-color: #16558f;
    display: grid;
    justify-content: center;
    align-items: center;
    transition: inherit;

    img {
      border-radius: inherit;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .initials {
      color: #ffffff;
    }
  }
  &:hover {
    background-color: #3d8cb7;
    .avatar_body {
      background-color: #277faf;
    }
  }
}
.v-menu__content {
  filter: drop-shadow(0px 4px 4px rgba(37, 120, 173, 0.2));
  box-shadow: none;
}

.avatarList {
  padding: 0;
  max-width: 20em;
  border-radius: 0px 0px 10px 10px !important;

  .v-list {
    filter: none !important;
    border-radius: 0px 0px 10px 10px !important;
  }

  .v-list-item {
    padding: 10px 20px !important;
    min-height: 25px;
    transition: 0.3s;

    span {
      transition: inherit;
      color: #277faf;
      font-weight: bold;
      font-size: 17px;
    }

    &:hover {
      background: #277faf;

      span {
        color: #ffffff;
      }
    }

    &.email {
      background: #daedf8;
      font-weight: normal;
      font-size: 17px;
      display: block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: normal;

      span {
        color: #52525f;
        font-weight: normal;
      }
    }

    &.exit {
      span {
        color: #ec1b0e;
      }

      &:hover {
        background: #ec1b0e;

        span {
          color: #ffffff;
        }
      }
    }

    &:last-of-type {
      border-radius: 0px 0px 10px 10px;
    }
  }
}
</style>
